import { type FC, useMemo } from 'react';
import InputSelect from '@components/InputSelect';
import type { EvalWorkflowType } from '@root/domain/schemas/evals/eval-config.schema';

import { getWorkflowPackExpectations } from '../constants';

interface RolePickerProps {
  workflowType: EvalWorkflowType;
  value: string;
  onChange: (value: string) => void;
  dataTestId?: string;
  labelText?: string;
  isRequired?: boolean;
}

export const RolePicker: FC<RolePickerProps> = ({
  workflowType,
  value,
  onChange,
  dataTestId,
  labelText = 'Role',
  isRequired,
}) => {
  const expectations = getWorkflowPackExpectations(workflowType);
  const options = useMemo(
    () =>
      expectations.expectedPromptRoles.map(({ role, description }) => ({
        value: role,
        name: description ? `${role} — ${description}` : role,
      })),
    [expectations],
  );

  return (
    <InputSelect
      labelText={labelText}
      isRequired={isRequired}
      options={options}
      value={value}
      onChange={(next) => onChange((next as string) ?? '')}
      isSearchable={false}
      dataTestId={dataTestId ? `${dataTestId}:select` : 'role-picker:select'}
      placeholder="Select role"
      descriptionText="Each prompt is tied to a specific lens defined by the workflow."
    />
  );
};
